import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from '../containers/auth/auth.service';


@Injectable()
export class AuthGuard implements CanActivate {


  constructor(
    public auth: AuthService,
    public router: Router
  ) { }


  canActivate(): boolean {
    if (!this.auth.getToken()) {
      this.router.navigateByUrl('/auth/login');
      return false;
    } else {
      if (!this.auth.isValidToken()) {
        this.auth.logout().subscribe(() => {
          this.router.navigateByUrl('/auth/login');
        }).unsubscribe();
        return false;
      }
    }
    return true;
  }
}